import React, { useState } from "react";
import './recetario.css'

export default function ListaRecetarioForm() {
  // Productos que son grupos (con variantes relacionadas)
  const grupos = {
    pasteles: {
      id: 2,
      nombre: "PASTELES",
      tipo: "grupo",
      principal: { key: "kilosPastel", label: "KILOS DE PASTEL" },
      variantes: [
        { key: "pastelJamonQueso", label: "PASTEL DE JAMÓN Y QUESO" },
        { key: "pastelCarne", label: "P. DE CARNE" },
        { key: "pastelPollo", label: "P. DE POLLO" },
        { key: "milhojas", label: "MILHOJAS" },
        { key: "cachitos", label: "CACHITOS" },
        { key: "pastelCarneBocadito", label: "P. DE CARNE BOCADITO" },
        { key: "pastelPolloBocadito", label: "P. DE POLLO BOCADITO" },
        { key: "milhojasBocadito", label: "MILHOJAS BOCADITO" },
        { key: "cachitosBocadito", label: "CACHITOS BOCADITO" }
      ]
    },
    biscochuelos: {
      id: 3,
      nombre: "BISCOCHUELOS",
      tipo: "grupo",
      principal: { key: "tandabiscochuelos", label: "TANDA DE BISCOCHUELOS" },
      variantes: [
        { key: "rectangular", label: "B. RECTANGULAR" },
        { key: "redondagrande", label: "B. REDONDA GRANDE" },
        { key: "redondamediana", label: "B. REDONDA MEDIANA" },
        { key: "redondachica", label: "B. REDONDA CHICA" },
      ]
    }
  };

  // Productos individuales (cada uno es independiente)
  const productosIndividuales = {
    hojarascasLata: {
      id: 1,
      nombre: "HOJARASCAS (LATA)",
      key: "latasHojarascas",
      label: "LATAS DE HOJARASCAS"
    },
    hojarascasBocadito: {
      id: 2,
      nombre: "HOJARASCAS BOCADITO (LATA)",
      key: "latasHojarascasBocadito",
      label: "LATAS DE HOJARASCAS DE BOCADITO"
    },
    cremaMantequilla: {
      id: 3,
      nombre: "CREMA DE MANTEQUILLA",
      key: "tandaCremaManteq",
      label: "TANDA DE CREMA DE MANTEQUILLA"
    }
  };

  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="order-form-container">
      <div>
        <div className="form-actions">
          <button type="button" className="btn-verde-mfp">Emitir Pedido</button>
          <button type="button" className="btn-anular ml-1">Cancelar</button>
        </div>
      </div>
      
      <div className="bakery-order-form">
        <div className="abed_content-fecha">
          <label>Registro:</label> <input type="date" className="abed__input-fecha" readOnly />
        </div>
        {/* Renderizar grupos */}
        {Object.values(grupos).map((grupo) => (
          <div key={grupo.id} className="order-section grupo-section">
            
          <div className="grupo-container">
            <div className="grupo-principal">
                <div className="input-group principal-input">
                  <label>{grupo.principal.label}</label>
                  <input 
                    type="number" 
                    name={grupo.principal.key}
                    value={formData[grupo.principal.key] || ''}
                    onChange={handleChange}
                    className="abed__input-numero"
                    placeholder="Cantidad"
                  />
                </div>
              </div>

              {/* Variantes del grupo */}
              <div className="grupo-variantes">
                {grupo.variantes.map((variante) => (
                  <div key={variante.key} className="abed__input-group variante-item">
                    <input
                      type="number"
                      name={variante.key}
                      value={formData[variante.key] || ''}
                      onChange={handleChange}
                      className="abed__input-numero"
                    />
                    <label className="abed__label-numero">{variante.label}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}

        {/* Renderizar productos individuales */}
        <div className="order-section productos-individuales-section">
          <h3 className="individuales-title">OTROS PRODUCTOS</h3>
          
          <div className="productos-individuales-container">
            {Object.values(productosIndividuales).map((producto) => (
              <div key={producto.id} className="abed__input-group producto-individual">
                <label>{producto.label}</label>
                <input
                  type="number"
                  name={producto.key}
                  value={formData[producto.key] || ''}
                  onChange={handleChange}
                  className="abed__input-numero"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}